// extracted by mini-css-extract-plugin
export var brandLogo = "SiteTitle-module--brand-logo--b3df0";
export var header = "SiteTitle-module--header--f6731";
export var siteTitle = "SiteTitle-module--site-title--97281";